import AtmosphericHero from '@/components/marketing/AtmosphericHero'
import { EmailForm, FlashMessages, HelpLine, SignInCard, type SignInPageProps } from '@/components/marketing/signin/SignInParts'

/**
 * /account-hub/log-in — unlisted and noindex. Unauthenticated deep links into
 * the portal land here, so a shared link signs the person straight in to the
 * page they were sent: the Account Hub form alone, never the Distribution
 * Dashboard door, and every submission carries `hub` so its errors and
 * back-links stay in this flow.
 */
export default function HubLogin(props: SignInPageProps) {
  return (
    <AtmosphericHero minHeight="auto" containerClassName="max-w-xl pt-8! lg:pt-10!">
      <div className="space-y-6">
        <FlashMessages {...props.flash} />
        <SignInCard
          eyebrow="Account Hub"
          title="Sign in to continue"
          lead={props.return_to
            ? 'Enter your email and we’ll send you a one-time code — you’ll land right back on the page you were opening.'
            : 'Enter your email and we’ll send you a one-time login code.'}
        >
          <EmailForm props={props} autoFocus />
        </SignInCard>
        <HelpLine props={props} />
      </div>
    </AtmosphericHero>
  )
}
